var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteriorPilotWeaponsSpecialist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3600 1800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #edbe7e;\n      }\n\n      .cls-2 {\n        fill: #898881;\n        opacity: .3;\n      }\n\n      .cls-3 {\n        fill: #3d9ea5;\n      }\n\n      .cls-4 {\n        fill: #2e8c8e;\n      }\n\n      .cls-5 {\n        isolation: isolate;\n      }\n\n      .cls-6 {\n        fill: #03b8ff;\n      }\n\n      .cls-7 {\n        fill: #353d3c;\n      }\n\n      .cls-8 {\n        fill: #664624;\n      }\n\n      .cls-9 {\n        fill: #995b0a;\n      }\n\n      .cls-10 {\n        fill: #0ee0e0;\n      }\n\n      .cls-11 {\n        fill: #4d5b5a;\n      }\n\n      .cls-12 {\n        fill: #2c8a8c;\n      }\n\n      .cls-13 {\n        fill: #c1e2e5;\n        mix-blend-mode: color-dodge;\n        opacity: .15;\n      }\n\n      .cls-14 {\n        fill: #f7edef;\n      }\n\n      .cls-15 {\n        fill: #222625;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Weapons_Specialist"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 460.87,
    y: 1486.01,
    width: 128.37,
    height: 501.82,
    transform: "translate(-1211.86 2261.97) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 642.03,
    y: 1601.02,
    width: 73.15,
    height: 129.08,
    transform: "translate(2476.63 1706.57) rotate(113.47)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "695.25 1407.94 713.38 1381.93 714.29 1352.57 660.62 1356.53 695.25 1407.94"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 327.41,
    y: 1604.96,
    width: 73.15,
    height: 129.08,
    transform: "translate(1750.34 670.63) rotate(66.53)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "355.22 1407.94 337.1 1381.93 336.19 1352.57 389.86 1356.53 355.22 1407.94"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-9",
    points: "490.22 1300.6 344.36 1362.13 301.85 1555.07 362.35 1622.54 409.77 1716.68 526.02 1776.42 641.94 1715.92 685.06 1622.54 749.86 1554.31 707.35 1361.37 561.49 1299.83 526.02 1325.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "525.32 1618.23 525.32 1618.23 527.47 1577.36 523.17 1577.36 525.32 1618.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "557.68 1624.89 562.78 1622.81 524.73 1613.48 523.93 1619.86 557.68 1624.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "492.46 1624.89 487.36 1622.81 525.41 1613.48 526.21 1619.86 492.46 1624.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "274.15 1801.1 775.41 1801.1 771.26 1482.82 732.38 1302.3 523.17 1239.6 317.17 1302.3 278.33 1482.82 274.15 1801.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "710.87 1801.1 799.08 1801.1 799.08 1510.67 771.11 1489.15 710.87 1801.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "250.48 1801.1 338.69 1801.1 278.45 1489.15 250.48 1510.67 250.48 1801.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "250.48 1681.5 206.09 1706.01 173.35 1801.1 250.48 1801.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "799.08 1681.5 843.47 1706.01 876.21 1801.1 799.08 1801.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 241.36,
    y: 1234.47,
    width: 23.66,
    height: 135.54,
    transform: "translate(-719.69 400.33) rotate(-36.17)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "523.01 1458.1 359.24 1234.05 380.08 1218.82 531.16 1425.5 523.01 1458.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "291.95 1142 455.73 1366.05 476.57 1350.82 325.49 1144.13 291.95 1142"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M794.7,1829.78l-137.21,100.29-88.87-121.58,45.16-33.01-279.3-382.1-69.74-.62-109.99-150.47,137.21-100.29,502.74,687.78ZM207.12,1251.97l67.29,92.05,114.51-3.76-105.37-144.16-76.42,55.86Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "365.47 1392.05 703.17 1854.05 710.12 1848.97 376.23 1392.18 365.47 1392.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "389.99 1392.78 727.69 1854.78 734.64 1849.7 400.75 1392.91 389.99 1392.78"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 728.78,
    y: 1627.92,
    width: 12.09,
    height: 219.44,
    transform: "translate(-883.82 768.45) rotate(-36.17)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 544.7,
    y: 1855.6,
    width: 150.59,
    height: 17.21,
    transform: "translate(-519.14 3464.85) rotate(-126.17)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "820.97 2127 237.03 2127 205 1723.7 311.75 1570.95 746.25 1570.95 853 1723.7 820.97 2127"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "725.15 2098.1 332.85 2098.1 302.85 1723.03 340.36 1673.03 714.5 1673.03 755.15 1723.03 725.15 2098.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteriorPilotWeaponsSpecialist);
export default __webpack_public_path__ + "static/media/interior-pilot-weapons-specialist.5d8d1af2bd7b5075f9d468b42500cad2.svg";
export { ForwardRef as ReactComponent };